module.exports = __webpack_public_path__ + "img/appAsset-bankingLogo__cl_banco_bci_White.87cb6327.svg";